export const LEDGER_TYPE_CODE = {
  //Ledger for shops
   CASH_BOOK_SH :   460011,
   CA_P_AND_P_SH :   460012,

   SEYLAN_BANK_SH : 460013,
   DFCC_SH : 460014,
   HNB_SH : 460015,

   CC_DFCC_SH : 460016,
   CC_HNB_SH : 460017,

   LOCKER :  4600111,


    //Ledger for stores
   CASH_BOOK_ST :   460021,
    
   CA_P_AND_P_ST :   460022,
    
   CA_FAZIL : 460023,
   CA_FAHIK : 460024,
   CA_FAHJI : 460025,

   SEYLAN_BANK_ST : 460026,
   DFCC_ST : 460027,
   HNB_ST : 460028,

   FAZIL_LOAN : 460029,
   FAHIK_LOAN : 4600210,
   FAHJI_LOAN : 4600211,


}